<div
  class="blog-style-2 blog-el-item opacity-0 translate-y-4 transition-all duration-100 ease-out animate-[fadeInUp_0.7s_ease-out_0.1s_forwards] flex flex-col h-full min-w-0"
>
  <div class="blog-images h-[240px] shrink-0">
    <a [href]="post.link" class="relative">
      <!-- <div class="w-full h-full bg-linear-to-r from-primary/5 to-primary/80"> -->
      <img
        decoding="async"
        [src]="post.imageUrl"
        class="attachment-full size-full w-full h-full object-cover object-center"
        [alt]="post.title"
      >
      <span class="absolute top-0 left-0 w-full h-full bg-linear-to-b from-primary/5 to-primary/50 z-10"></span>
      <!-- </div> -->
    </a>
    <div class="blog-date z-20">
      <span class="date">{{ post.date | date:'dd' }}</span>
      <span class="month">{{ post.date | date:'MMM' }}</span>
    </div>
  </div>
  <div class="blog-content grow flex flex-col">
    <div class="blog-two-meta blog-el-meta">
      <ul>
        @for (item of post.tags.slice(0, 3); track $index) {  
        <li>
          <a
            class="meta-link"
            [routerLink]="['/news/search', item?.title]"
          >
            {{ item?.title }}
          </a>
        </li>
        }
        <!-- <li>{{ post.comments }} Comments</li> -->
      </ul>
    </div>
    <h4 class="title under-line text-2xl font-semibold font-heading text-heading-primary wrap-break-word">
      <a [href]="post.link">
        {{ post.title }}
      </a>
    </h4>
    <div class="desc grow text-text-body wrap-break-word overflow-hidden">
      {{ post.description | slice:0:100 }}
      @if(post.description.length > 100) {
        <span>...</span>
      }
    </div>

    <div class="blog-button ">
      <a
        class="
        text-heading-primary flex items-center justify-center gap-2 relative underline-effect w-fit font-semibold text-base
          before:bg-heading-primary!
        "
        [routerLink]="post.link"
      >
        Leer más
        <i aria-hidden="true" class="material-symbols-outlined text-base!">
          arrow_right_alt
        </i>
      </a>
    </div>
  </div>
</div>